// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5yAwy","top":"styles_top__OJ5PU","left":"styles_left__3sHcs","description":"styles_description__eFeap"};